export default {"src":"/_next/static/media/dot.d662c5f2.svg","height":3,"width":3,"blurWidth":0,"blurHeight":0};